<div class="templateCharts">

  <!-- <h1 style="text-align: center; background-color: white">
    Welcome to {{ title }}!
  </h1> -->

  <ul class="nav nav-pills mb-3 justify-content-center mobileTab" id="myTab" role="tablist" style="font-size: 2rem;">
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link active navText" id="feed-tab" data-bs-toggle="pill" data-bs-target="#feed" type="button"
        role="tab" aria-controls="feed" aria-selected="true" style="font-size: large"><i
          class="fa-solid fa-square-rss"></i> Feed</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="stats-tab" data-bs-toggle="pill" data-bs-target="#stats" type="button"
        role="tab" aria-controls="stats" aria-selected="false" style="font-size: large"><i
          class="fa-solid fa-chart-simple"></i> Stats</button>
    </li>
    <li class="nav-item" role="presentation" class="navItems">
      <button class="nav-link navText" id="port-tab" data-bs-toggle="pill" data-bs-target="#port" type="button"
        role="tab" aria-controls="port" aria-selected="false" style="font-size: large"><i
          class="fa-solid fa-chart-pie"></i> Portfolio</button>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active feedTab" id="feed" role="tabpanel" aria-labelledby="feed-tab">
      <div class="row" style="margin: auto">
        <div class="col">
          <div>
            <div style="text-align: center; width:auto">
              <div style="margin:auto;">
                <div class="elfsight-app-1bd35861-fde3-4be5-9dfd-a51de5105af6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="tab-pane fade" id="stats" role="tabpanel" aria-labelledby="stats-tab">
      <div class="row perfMarg">
        <div class="col">
          <!-- <div id="containerNewPerf" class="perfCon" style="text-align: center;"></div> -->
          <app-main-graph></app-main-graph>
        </div>
      </div>
      <div class="row" style="margin: auto">
        <div class="col avgMarg">
          <div style="text-align: center; margin: auto;">
            <div style="margin:auto;">
              <section class="section" style="padding-bottom: 0rem" id="about">
                <div class="shell shell--size-3">
                  <div class="section__head">
                    <h6>Algorithm</h6>
        
                    <h2>Risk Score</h2>
                  </div><!-- /.section__head -->
                </div>
              </section>
              <div id="containerRisk" class="riskCon" style="text-align: center; margin: auto"></div>
            </div>
          </div>
          <p style="font-size: large">Average Risk Score: {{riskText}}</p>
        </div>
      </div>
      <br />
      <div class="row" style="margin: auto">
        <div class="col copyMarg">
          <div style="text-align: center; margin: auto;">
            <div class="card-text" style="margin:auto;">
              <section class="section" style="padding-bottom: 0rem" id="about">
                <div class="shell shell--size-3">
                  <div class="section__head">
                    <h6>Algorithm</h6>
                    
                    <h2>Copiers History</h2>
                  </div><!-- /.section__head -->
                </div>
              </section>
              <div id="copiersContainer" class="copiersCon" style="text-align: center; margin:auto"></div>
            </div>
            <div style="font-size: large">We currently have <b>{{recentCopiers}}</b> traders copy
              trading us!</div>
            </div>
        </div>
      </div>
      <br />
    </div>

    <div class="tab-pane fade" id="port" role="tabpanel" aria-labelledby="port-tab">
      <div>
        <div>
          <div class="card">
            <div class="card-body" style="text-align: center; margin: auto; font-size: large">
              <div class="card-title"><b>Live Portfolio</b></div>
              This is our live portfolio, and will update frequently
              <span class="card-text" class="table table-striped">
                <div class="portfolioTab">
                  <thead>
                    <tr>
                      <th class="portHeading">Name</th>
                      <th class="portHeading">Investment %</th>
                      <th class="portHeading">Net Profit</th>
                      <th class="portHeading">Open Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let position of portfolioPositions">
                      <td class="portHeading portLeft" style="text-align: left;">{{position.positionId}}</td>
                      <td class="portHeading">{{position.investmentPct}}</td>
                      <td class="portHeading">{{position.netProfit}}</td>
                      <td class="portHeading">{{position.openRate}}</td>
                    </tr>
                  </tbody>
                </div>

              </span>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
  <br/>
  <div *ngIf="mobile">

    <section class="section-image btn-pos" id="etoroLoc" style="margin-top: 30px; margin-bottom: -60px">
      <div class="shell">
        <div class="section__content" style="margin-bottom: 25%">
          <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
            class="btn btn--size-2" target="_blank">Join us on eToro</a>
        </div>
      </div>
    </section>
  </div>
  <div *ngIf="!mobile">
    <section class="section-image btn-pos" id="etoroLoc" style="margin-top: 30px; margin-bottom: -60px">
      <div class="shell">
        <div class="section__content">
          <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
            class="btn btn--size-2" target="_blank">Join us on eToro</a>
        </div>
      </div>
    </section>
  </div>

</div>